

import {Component, Prop, Ref, Vue, Watch} from "vue-property-decorator";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import TebligatList from "@/components/anakart/tebligat/TebligatList.vue";
import HacizList from "@/components/lists/haciz/HacizList.vue";
import {BorcluEntity} from "@/entity/BorcluEntity";
import {TakipDurumu} from "@/enum/TakipDurumu";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import NotList from "@/components/lists/NotList.vue";
import {NotTuru} from "@/enum/NotTuru";
import {ProgramPaths} from "@/enum/ProgramPaths";
import {TakipTalebiEntity} from "@/entity/TakipTalebiEntity";
import {BorcluVekiliEntity} from "@/entity/BorcluVekiliEntity";
import BorcluVekiliForm from "@/components/forms/BorcluVekiliForm.vue";
import FormWrapper from "@/components/FormWrapper.vue";
import {TebligatDurumu} from "@/enum/TebligatDurumu";
import {DavaSonucu} from "@/enum/DavaSonucu";
import UyapEvrakGonderForm from "@/components/forms/UyapEvrakGonderForm.vue";
import HacizTalepList from "@/components/lists/haciz/HacizTalepList.vue";
import {AlacakEntity} from "@/entity/AlacakBelgeler/AlacakEntity";
import {TebligatEntity} from "@/entity/TebligatEntity";
import {AdresTuru} from "@/enum/AdresTuru";
import {adresIlceSorunu} from "@/helpers/AdresIlceDenetimi";


@Component({
  components: {
    HacizTalepList,
    UyapEvrakGonderForm,
    FormWrapper,
    BorcluVekiliForm,
    NotList,
    FormDialog,
    DeleteDialog,
    TebligatList,
    HacizList
  }
})

export default class BorcluCardInfo extends Vue {
  @Prop() borclu!: any;
  @Prop() borcluVekili!: BorcluVekiliEntity;
  @Prop() takipDurumu!: TakipDurumu;
  @Prop() takipId !: number;
  @Prop() takip !: any;
  @Prop() vekiller !: Array<BorcluVekiliEntity>;
  @Ref('notList') readonly notList!: NotList;

  TakipDurumu = TakipDurumu;
  notTuru = NotTuru;
  isTakipTipiRehin = false;
  show = false;
  selected: number | undefined = 0;
  borcluNotlar:any = []
  borcluTebligatlar:Array<TebligatEntity> = []

  headers = [
    {text: "Sabit Telefon", value: "deger"},
    {text: "Mobil Telefon", value: "deger"},
    {text: "E-posta", value: "deger"},
    {text: "Web Sitesi", value: "deger"},
    {text: "Faks", value: "deger"},
    {text: "Sosyal Medya", value: "deger"}
  ];

  iletisimTuruIkon(iletisimTurId: number): string {
    switch (iletisimTurId) {
      case 1:
        return 'mdi-phone';
      case 2:
        return 'mdi-cellphone';
      case 3:
        return 'mdi-email-outline';
      case 4:
        return 'mdi-web';
      case 5:
        return 'mdi-fax';
      case 6:
        return 'mdi-share-variant-outline';
      default:
        return 'mdi-card-account-phone-outline';
    }
  }

  get borcluIletisimHamListe(): any[] {
    if (!this.borclu) {
      return [];
    }
    if (Array.isArray(this.borclu.iletisim_bilgileri)) {
      return this.borclu.iletisim_bilgileri;
    }
    if (this.borclu.kisi_id && this.borclu.kisi && Array.isArray(this.borclu.kisi.iletisim_bilgileri)) {
      return this.borclu.kisi.iletisim_bilgileri;
    }
    if (this.borclu.kurum_id && this.borclu.kurum && Array.isArray(this.borclu.kurum.iletisim_bilgileri)) {
      return this.borclu.kurum.iletisim_bilgileri;
    }
    return [];
  }

  get borcluIletisimSatirlari(): Array<{ key: string | number; label: string; deger: string; icon: string }> {
    const liste = this.borcluIletisimHamListe;
    if (!liste.length) {
      return [];
    }
    const out: Array<{ key: string | number; label: string; deger: string; icon: string }> = [];
    for (let i = 0; i < liste.length; i++) {
      const item = liste[i];
      const turId = item.iletisim_tur_id as number;
      const headerIndex = turId - 1;
      if (turId >= 1 && turId <= this.headers.length) {
        const rawVal = this.getPropValue(item, this.headers[headerIndex].value);
        if (rawVal === null || rawVal === undefined || rawVal === 'Bilgi yok') {
          continue;
        }
        const deger = String(rawVal).trim();
        if (!deger) {
          continue;
        }
        out.push({
          key: item.id != null ? item.id : `iletisim-${i}`,
          label: this.headers[headerIndex].text,
          deger,
          icon: this.iletisimTuruIkon(turId)
        });
      } else {
        const d = item.deger != null ? String(item.deger).trim() : '';
        if (!d) {
          continue;
        }
        out.push({
          key: item.id != null ? item.id : `iletisim-${i}`,
          label: 'İletişim',
          deger: d,
          icon: 'mdi-card-account-phone-outline'
        });
      }
    }
    return out;
  }

  get borcluKimlikSatirlari(): Array<{ key: string; label: string; deger: string; icon: string }> {
    if (!this.borclu) {
      return [];
    }
    const out: Array<{ key: string; label: string; deger: string; icon: string }> = [];
    const tcRaw = this.borclu.tc_kimlik_no;
    if (tcRaw !== null && tcRaw !== undefined && String(tcRaw).trim() !== '') {
      out.push({
        key: 'tc',
        label: 'TC Kimlik No',
        deger: String(tcRaw).trim(),
        icon: 'mdi-card-account-details-outline'
      });
    }
    const vergiRaw = this.borclu.vergi_no;
    if (vergiRaw !== null && vergiRaw !== undefined && String(vergiRaw).trim() !== '') {
      out.push({
        key: 'vergi',
        label: 'Vergi No',
        deger: String(vergiRaw).trim(),
        icon: 'mdi-domain'
      });
    }
    return out;
  }

  get takipBilgileriTakipDurumu() {
    // Önce prop'u kontrol et
    if (this.takip && this.takip.takip_durumu) {
      return this.takip.takip_durumu;
    }

    // Sonra store'dan al
    const route = this.$route.path;
    if (route.includes('/icrapro/takip/') && !route.includes('/takip-ekle/')) {
      return this.$store.state.takipDetay?.takip?.takip_bilgileri?.takip_durumu;
    }
    return this.$store.state.takipEkle?.item?.takip_bilgileri?.takip_durumu;
  }

  clickNotlar(){
    if(this.takipBilgileriTakipDurumu !== this.TakipDurumu.acilmamis){
      this.$http.get('/api/v1/borclu/' + this.borclu.id + '/notlar').then((response)=>{
        this.borcluNotlar = response.data.notListesi;
      })
    }

  }

  get tebligatIconColor() {
    if (this.borcluTebligatlar && this.borcluTebligatlar.length > 0) {
      let tebligat = this.borcluTebligatlar[this.borcluTebligatlar.length - 1];
      if (tebligat.tebligat_durumu == TebligatDurumu.bila_oldu) return '#d26363';
      else if (tebligat.tebligat_durumu == TebligatDurumu.teblig_edildi) {
        if (!tebligat.itiraz_var_mi) return '#63d269';
        else return '#e5dd5a';
      } else return 'white';
    } else return 'white';
  }

  get showHaciz() {
    if (!this.isTakipTipiRehin && this.borclu.takip.takip_durumu === TakipDurumu.acik && this.borclu.tebligatlar && this.borclu.tebligatlar.length > 0) {
      // Tebliğ edildi ve itiraz edilmedi ise veya itirazın iptali/kaldırılması davasında  kabul veya kısmi kabul olur ise haciz butonu öyle gözükecek.
      let tebligat = this.borclu.tebligatlar[this.borclu.tebligatlar.length - 1];
      if (tebligat.tebligat_durumu == TebligatDurumu.teblig_edildi && !tebligat.itiraz_var_mi)
        return true;
      else if (tebligat.tebligat_durumu == TebligatDurumu.teblig_edildi && tebligat.itiraz_var_mi && (tebligat.itirazin_iptali_davasi[0]?.dava_sonucu == DavaSonucu.kabul || tebligat.itirazin_iptali_davasi[0]?.dava_sonucu == DavaSonucu.kismi_kabul))
        return true;
      else return false;
    } else return false;
  }

  get kisiKurumId() {
      return this.borclu.uyap_kisi_kurum_id;
  }

  get evrakGonderTooltip() {
    if (this.$helper.isAuthorized('borclu-evrak-gonder')) {
      if (this.$store.getters.isUyapConnected)
        return 'UYAP Evrak Gönder'
      else
        return 'UYAP Bağlantısını Yapınız'
    } else
      return 'Bu işlem için yetkiniz yok.'
  }

  borcluAdresIlceMetni(ad: { ilce?: { isim?: string } | string } | null): string {
    if (!ad || ad.ilce == null) {
      return '';
    }
    if (typeof ad.ilce === 'string') {
      return ad.ilce.trim();
    }
    return ((ad.ilce as { isim?: string }).isim || '').toString().trim();
  }

  borcluAdresSehirMetni(ad: { sehir?: { isim?: string } | string } | null): string {
    if (!ad || ad.sehir == null) {
      return '';
    }
    if (typeof ad.sehir === 'string') {
      return ad.sehir.trim();
    }
    return ((ad.sehir as { isim?: string }).isim || '').toString().trim();
  }

  get borcluAdresIlceSehirSatiri(): string {
    const ad = this.borclu.varsayilan_adres;
    if (!ad) {
      return '';
    }
    const ilce = this.borcluAdresIlceMetni(ad);
    const sehir = this.borcluAdresSehirMetni(ad);
    if (ilce && sehir) {
      return `${ilce} / ${sehir}`;
    }
    return ilce || sehir;
  }

  /**
   * Varsayılan adresin ilçesi eksik/geçersizse XML'e ilçesiz çıkar; kartta görünsün (DEV-2726).
   * Takip detayı bu adresi JOIN'le (il/ilçe adı metin, id yok) ve borçlunun adresi hiç
   * yoksa da tüm alanları boş bir nesne olarak döndürür; o durum ilçe sorunu değildir.
   */
  get borcluAdresIlceSorunu(): string | null {
    const ad = this.borclu?.varsayilan_adres;
    if (!ad || (ad.adres_tur_id == null && ad.sehir_id == null && ad.ilce_id == null && !ad.adres)) {
      return null;
    }
    return adresIlceSorunu(ad, true);
  }

  get borcluAdresIlceUyarisi(): string {
    const sorun = this.borcluAdresIlceSorunu || '';
    return sorun.charAt(0).toLocaleUpperCase('tr') + sorun.slice(1)
      + ' — borçluyu düzenleyip adresi kalem simgesiyle açın, il ve ilçeyi yeniden seçin.';
  }

  get adresTurKisaEtiket(): string {
    const ad = this.borclu.varsayilan_adres;
    if (!ad) {
      return 'Adres';
    }
    const raw = (ad as { adres_turu_isim?: string; adres_turu?: { isim?: string } }).adres_turu_isim
      || (ad as { adres_turu?: { isim?: string } }).adres_turu?.isim;
    return (raw && String(raw).trim()) ? String(raw).trim() : 'Adres';
  }

  get borcluAdresAcikMetin(): string {
    const ad = this.borclu.varsayilan_adres;
    if (!ad) {
      return '';
    }
    const satir = (ad as { adres?: string }).adres != null
      ? String((ad as { adres?: string }).adres).trim()
      : '';
    const lok = this.borcluAdresIlceSehirSatiri;
    if (satir && lok) {
      return `${satir} · ${lok}`;
    }
    return satir || lok;
  }

  get borcluAdresListeMetni(): string {
    const ad = this.borclu.varsayilan_adres;
    if (!ad) {
      return '';
    }
    const turId = (ad as { adres_tur_id?: number }).adres_tur_id;
    if (turId === AdresTuru.mernis) {
      return 'Mernis adresi';
    }
    if (turId === AdresTuru.mersis) {
      return 'Mersis adresi';
    }
    return this.borcluAdresAcikMetin || this.adresTurKisaEtiket;
  }

  get borcluAdresTooltipIcerik(): string {
    const ad = this.borclu.varsayilan_adres;
    if (!ad) {
      return '';
    }
    const turId = (ad as { adres_tur_id?: number }).adres_tur_id;
    const detay = this.borcluAdresAcikMetin;
    if (turId === AdresTuru.mernis) {
      return detay ? `Mernis — ${detay}` : 'Varsayılan adres türü: Mernis';
    }
    if (turId === AdresTuru.mersis) {
      return detay ? `Mersis — ${detay}` : 'Varsayılan adres türü: Mersis';
    }
    return detay || this.adresTurKisaEtiket;
  }

  get borcluVekilleri(): BorcluVekiliEntity[] {
    if (!this.borclu || !Array.isArray(this.borclu.vekiller)) {
      return [];
    }
    return this.borclu.vekiller;
  }

  vekilAdSoyad(vekil: BorcluVekiliEntity): string {
    const ad = (vekil.ad || '').trim();
    const soyad = (vekil.soyad || '').trim();
    const full = `${ad} ${soyad}`.trim();
    return full || '—';
  }

  vekilAdresMetni(vekil: BorcluVekiliEntity): string {
    const adr = vekil.adres;
    if (!adr) {
      return '';
    }
    if (adr.adres_tur_id === AdresTuru.mernis) {
      return 'Mernis Adresi';
    }
    if (adr.adres_tur_id === AdresTuru.mersis) {
      return 'Mersis Adresi';
    }
    const line = `${adr.adres || ''} ${adr.ilce && adr.ilce.isim ? adr.ilce.isim : ''} / ${adr.sehir && adr.sehir.isim ? adr.sehir.isim : ''}`.trim();
    return line.replace(/^\s*\/\s*|\s*\/\s*$/g, '').replace(/\s+/g, ' ').trim();
  }

  mounted() {
    this.takipTipiRehinMi(this.borclu);
  }

  selectedId() {
    if (this.borclu.kisi_id) {
      this.selected = this.borclu.kisi.varsayilan_adres?.id;
      return this.selected;
    } else {
      this.selected = this.borclu.kurum.varsayilan_adres.id;
      return this.selected;
    }
  }

  getPropValue(data: any, key: string): any {
    if (!key.includes('.')) {
      return data[key];
    }
    let props = key.split('.');
    let value = data;
    props.forEach((prop: string) => {
      if (!value || !value.hasOwnProperty(prop)) {
        value = "Bilgi yok";
        return;
      }
      value = value[prop];
    });
    return value;
  }

  detay(item: BorcluEntity) {
    if (item.id ! > 0) {
      this.$router.push(ProgramPaths.icrapro + "/borclu/" + item.id);
    }
  }

  takipTipiRehinMi(item: BorcluEntity) {
    if (item.takip) {
      item.takip.talepler.forEach((talepler: TakipTalebiEntity) => {
        if (talepler.takip_tipi.rehin_mi) {
          this.isTakipTipiRehin = true;
        }
      });
    }
  }

  load() {
    this.$emit('load')
  }

  isAuthorized(keySuffix: string) {
    let ap = this.$store.state.activeProcesses;
    let authKey = null;
    if (keySuffix[0] !== '-') {
      keySuffix = '-' + keySuffix;
    }
    if (ap.filter((item: any) => item.key === "takip-ac").length > 0) {
      authKey = "takip-ac";
    } else if (ap.filter((item: any) => item.key === "takip-duzenle").length > 0) {
      authKey = "borclu" + keySuffix;
    }
    if (!authKey) {
      return false;
    }
    return this.$helper.isAuthorized(authKey)
  }

  onClose() {
    this.show = false;
  }

  onSuccess(data: any) {
    this.onClose();
    this.$emit("success", data);
  }
}
